import axiosInstance from '@/axiosInstance';

export interface DocType {
  docTypeID: number;
  docTypeName: string;
  description: string;
}

export default {
  async getDocTypes(): Promise<DocType[]> {
    try {
      const response = await axiosInstance.get('/api/DocType');
      return response.data;
    } catch (error) {
      console.error('Error fetching doc types:', error);
      throw error;
    }
  }
};
